<template>
  <div>
    <el-button @click="drawer = true" type="primary" style="margin-left: 16px;">
      {{ btnText }}
    </el-button>
    <el-drawer
        :title="title"
        :visible.sync="drawer"
        :direction="direction"
        :size="size">
      <slot></slot>
    </el-drawer>
  </div>
</template>

<script>

export default {
  name: "Drawer",
  props: {
    size: {
      type: String,
      default: "50%",
    },
    title: {
      type: String,
      default: "Drawer Title"
    },
    btnText: {
      type: String,
      default: 'Add Comment'
    }
  },
  data() {
    return {
      drawer: false,
      direction: 'rtl',
    };
  },
  methods: {}
}
</script>

<style scoped>

</style>